<template>
  <div class="row card animated zoomIn">
    <div class="col s12 m12">
      <h5>
        <strong>
          Announcement
        </strong>
      </h5>
    </div>
    <div class="col s12 m12">
      <p class="text-justify">
        Dear Merchant, effective from today 07/02/21, we will be discontinuing the
        use of the unique virtual providus bank account assigned to you for
        funding your wallet. In the coming days, we will be providing you with new
        account numbers that will be more stable and have less downtime issues. In
        the meantime, please use any of the following account numbers to fund your
        wallet;
      </p>
    </div>
    <br />
    <div class="col s12 m12">
      <ul>
        <li>
          GTBANK  <br>
          iRecharge Tech Innovation Ltd <br>
          0460540637
        </li>
        <li>
          FIDELITY BANK  <br>
          iRecharge Tech Innovation Ltd <br>
          1023588803
        </li>
        <li>
          STERLING BANK  <br>
          iRecharge Tech Innovation Ltd <br>
          0079785386
        </li>
      </ul>
    </div>
    <div class="col s12 m12">
      <p class="text-justify">
        <strong>
          Please remember to fill in your transaction narration/description with
          your vendor ID. If you experience any challenges or need further
          clarification, please reach out to us on 08149906336
        </strong>
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MerchantAnouncement',
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>
<style scoped>
ul li {
  list-style-type: circle;
  margin-left: 30px;
  text-align: left;
}
.card {
  padding: 15px 20px;
}
</style>
